<template>
    <div class="recharge">
      <Modal
        :value="rechargeVisible"
        :scrollable="true"
        :mask-closable="false"
        :closable="false"
        :transfer="false"
        width="1008px"
        class-name="recharge"
        :footer-hide="true"
        @on-cancel="handleCancel">
        <v-loading :loading="loading"></v-loading>
        <Button class="recharge__btn--close"
                @click="handleCancel"
                shape="circle">关闭</Button>
        <div class="recharge-balance"
             v-if="rechargeType === '0' && dataList.length"
             :style="{height: bodyHeight}">
          <div class="recharge-balance__header flex flex--align-center flex--justify-between">
            <div>
              <img src="../../../assets/common/card_giftcard-gradient.svg">
              <div class="title">
                <h2>余额充值</h2>
                <p>请选择合适的充值套餐<p/>
              </div>
            </div>
            <div class="description">
              <Button class="custom"
                      @click="handleTypeChange('1')"
                      shape="circle">自定义充值</Button>
              <p class="description">自定义充值不能低于10000元，且不附加额外优惠</p>
            </div>
          </div>
          <div class="recharge-balance__body-list">
            <div :class="'list-item' + (index === selectIndex ? ' active' : '')"
                  @click="selectIndex = index"
                  v-for="(item, index) in dataList"
                  :key="item.id">
              <h3 class="list-item__title">{{item.activity_name}}</h3>
              <div class="list-item__body">
                <div class="amount">
                  <p class="num">￥{{item.amount | formatNum}}</p>
                  <p class="tag">送￥{{item.gift_amount | formatNum}}</p>
                  <div class="star">
                    <v-icon type="iconchongzhi" size="12"></v-icon>
                    <img src="../../../assets/common/Star.svg" v-if="selectIndex === index">
                    <img src="../../../assets/common/Star_normal.svg" v-else>
                  </div>
                </div>
                <div class="detail">
                  <p>{{item.description}}</p>
                  <p>充值满{{item.amount | formatNum}}元，将附送额外{{item.gift_amount | formatNum}}元</p>
                  <p>活动截止于 {{item.deadline}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="recharge-balance__body">
            <div class="recharge-balance__body-order">
              <div class="title">订单明细</div>
              <ul class="order-list">
                <li class="order-item flex flex--align-center flex--justify-between">
                  <p class="label">充值金额</p>
                  <p class="value">+ ¥{{dataList[selectIndex].amount | formatNum}}</p>
                </li>
                <li class="order-item flex flex--align-center flex--justify-between">
                  <p class="label">礼包充值金额</p>
                  <p class="value">+ ¥{{dataList[selectIndex].gift_amount | formatNum}}</p>
                </li>
                <li class="order-item flex flex--align-center flex--justify-between">
                  <p class="label">活动优惠 {{dataList[selectIndex].gift_amount | formatNum}}</p>
                  <p class="value">- ¥{{dataList[selectIndex].gift_amount | formatNum}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="recharge-balance__footer flex flex--justify-between">
            <p class="label">待支付金额</p>
            <div>
              <p class="label">￥{{dataList[selectIndex].amount | formatNum}}</p>
              <Button shape="circle"
                      @click="handleSubmitRecharge"
                      :loading="loading"
                      type="primary">确认订单</Button>
            </div>
          </div>
        </div>
        <div class="recharge-custom"
             :style="{height: bodyHeight}"
             v-else-if="rechargeType === '1'">
          <div class="recharge-custom__header">
            <v-icon type="iconround-clear-24px"
                    v-if="dataList.length"
                    @click.native="handleTypeChange('0')"></v-icon>
            <div class="title">
              <h2>自定义充值</h2>
              <p>自定义充值不能低于10000元，且不附加额外优惠</p>
            </div>
          </div>
          <div class="recharge-custom__body">
            <div class="flex flex--justify-center">
              <div class="icon-wrapper">
                <v-icon type="iconpayment-24px" size="24"></v-icon>
              </div>
              <Form label-position="top" :model="formData">
                <h3>定义充值金额（金额不能低于10000元）</h3>
                <FormItem prop="count"
                          label="自定义充值金额（元/只能为整数）">
                  <v-format-input type="text"
                                  placeholder="输入数字，例如150000"
                                  v-model="formData.amount">
                    <span slot="append">.00元整</span>
                  </v-format-input>
                </FormItem>
              </Form>
            </div>
            <Button type="primary"
                    long
                    shape="circle"
                    @click="handleSubmitRecharge"
                    :disabled="isSubmitDisabled">确认并充值</Button>
          </div>
        </div>
        <div class="recharge-pay"
             :style="{height: bodyHeight}"
             v-else>
          <div class="recharge-pay__header">
            <h2>汇款详情</h2>
            <p>请确认打款信息并开始汇款</p>
          </div>
          <div class="recharge-pay__body">
            <div class="recharge-pay__body-detail">
              <h3>汇款明细</h3>
              <template v-if="rechargeType === '2'">
                <ul>
                  <li class="flex flex--justify-between flex--justify-center"
                      :key="index"
                      v-for="(line, index) in rechargeDetail.lineList || []">
                    <p>{{line.name}}</p>
                    <p>{{line.type}}￥{{line.value | formatNum}}</p>
                  </li>
                </ul>
                <div class="flex flex--justify-center flex--justify-between">
                  <h2>待支付金额</h2>
                  <h2>¥{{rechargeDetail.line4.value | formatNum}}</h2>
                </div>
              </template>
            </div>
            <div class="recharge-pay__body-info">
              <Row :gutter="18">
                <Col :span="12">
                  <h3>汇款信息</h3>
                  <ul>
                    <li>
                      <p class="label">收款公司名称</p>
                      <p class="value">苏州体素信息科技有限公司</p>
                    </li>
                    <li>
                      <p class="label">收款账号</p>
                      <p class="value">325387509018800002680</p>
                    </li>
                    <li>
                      <p class="label">开户银行地址</p>
                      <p class="value">交通银行张家港保税区支行</p>
                    </li>
                    <li>
                      <p class="label">备注信息</p>
                      <p class="value">{{rechargeDetail.num}}</p>
                      <p class="remark">汇款必填备注信息，如果遗漏请及时联系我们的客服</p>
                    </li>
                  </ul>
                </Col>
                <Col :span="12">
                  <h3>温馨提示</h3>
                  <ul>
                    <li class="flex flex--justify-center flex--justify-between top">
                      <p class="value">1.</p>
                      <p class="value">
                        受银行处理时间影响，线下汇款方式到账会有延误。到账时间一般为：交通银行1-2个工作日，跨行3-5个工作日（具体到账时间以银行的实际到账时间为准）。
                      </p>
                    </li>
                    <li class="flex flex--justify-center flex--justify-between">
                      <p class="value">2.</p>
                      <p class="value">
                        汇款完成后，我们会在1个工作日内为您入款。在汇款过程中，如有任何问题请联系我们客服咨询，谢谢！
                      </p>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </div>
          <div class="recharge-pay__footer">
            <Button type="primary"
                    long
                    @click="updateState({ rechargeVisible: false })"
                    shape="circle">知道了，之后再汇款</Button>
            <Button type="text"
                    :disabled="rechargeDetail.pay_flag === 'Y'"
                    @click="handleNoticeRecharge"
                    long>通知对方，我已汇款</Button>
          </div>
        </div>
      </Modal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getCurrentActivity, confirmBillPay } from '@/api/settlement/bill';
import { submitRecharge, confirmRechargePay } from '@/api/settlement/balance';

export default {
  name: 'recharge',
  data() {
    return {
      dataList: [],
      formData: {},
      rules: {
        amount: [
          { required: true, message: '请输入自定义充值金额', trigger: 'blur' },
        ],
      },
      selectIndex: 0,
      loading: false,
      id: '',
    };
  },
  computed: {
    ...mapState(['windowSize', 'rechargeVisible', 'rechargeType', 'rechargeDetail']),
    bodyHeight() {
      return `${this.windowSize.height - 112}px`;
    },
    isSubmitDisabled() {
      return !this.formData.amount || this.formData.amount < 10000;
    },
  },
  watch: {
    rechargeVisible(val) {
      if (val) {
        this.selectIndex = 0;
      }
    },
  },
  created() {
    this.getCurrentActivity();
  },
  methods: {
    ...mapMutations(['updateState']),
    handleCancel() {
      this.updateState({
        rechargeVisible: false,
      });
    },
    handleTypeChange(type) {
      this.formData = {};
      this.updateState({
        rechargeType: type,
      });
    },
    async getCurrentActivity() {
      const res = await getCurrentActivity();
      if (res) {
        this.dataList = res.sort((a, b) => b.amount - a.amount);
      }
    },
    async handleSubmitRecharge() {
      const data = {};
      if (this.rechargeType === '0') {
        data.recharge_id = this.dataList[this.selectIndex].id;
      } else if (this.rechargeType === '1') {
        data.amount = this.formData.amount;
      }
      this.loading = true;
      const res = await submitRecharge({
        pay_flag: 'N',
        ...data,
      });
      this.loading = false;
      if (res) {
        this.$Message.success('提交成功');
        switch (this.rechargeType) {
          case '0':
            this.updateState({
              rechargeType: '2',
              rechargeDetail: {
                lineList: [
                  {
                    name: '充值金额',
                    value: this.dataList[this.selectIndex].amount,
                    type: '+',
                  }, {
                    name: '礼包充值金额',
                    value: this.dataList[this.selectIndex].gift_amount,
                    type: '+',
                  }, {
                    name: '活动优惠 ￥',
                    value: this.dataList[this.selectIndex].gift_amount,
                    type: '-',
                  },
                ],
                line4: {
                  name: '待支付金额',
                  value: this.dataList[this.selectIndex].amount,
                },
                num: res.journal_number,
                id: res.id,
                type: 'recharge',
              },
            });
            break;
          case '1':
            this.updateState({
              rechargeType: '2',
              rechargeDetail: {
                isGift: true,
                lineList: [
                  {
                    name: '充值金额',
                    value: this.formData.amount,
                    type: '+',
                  },
                ],
                line4: {
                  name: '待支付金额',
                  value: this.formData.amount,
                },
                num: res.journal_number,
                id: res.id,
                type: 'recharge',
              },
            });
            break;
          default:
            break;
        }
      }
    },
    async handleNoticeRecharge() {
      this.loading = true;
      let res = false;
      if (this.rechargeDetail.type === 'recharge') {
        res = await confirmRechargePay({
          id: this.rechargeDetail.id,
        });
      } else {
        res = await confirmBillPay({
          id: this.rechargeDetail.id,
        });
      }
      this.loading = false;
      if (res) {
        this.$Message.success('操作成功');
        this.updateState({
          rechargeVisible: false,
        });
      }
    },
  },
};
</script>

<style lang="less">
  .recharge{
    &.ivu-modal-wrap{
      overflow: auto;
    }
    .ivu-modal{
      min-width: 1008px;
      top: 112px;
      position: relative;
    }
    .ivu-modal-content{
      border-radius: 8px;
    }
    .ivu-modal-body{
      padding: 0;
    }
    &__btn--close{
      position: absolute;
      width: 88px;
      top: -48px;
      right: 0;
      color: @primary-color;
      box-shadow: none;
      border: none;
      padding: 0;
      height: 36px;
      font-weight: 500;
    }
    &-balance{
      padding-bottom: 32px;
      overflow: auto;
      &__header{
        padding: 24px;
        img{
          width: 88px;
          height: 88px;
          vertical-align: middle;
        }
        .title{
          display: inline-block;
          vertical-align: middle;
          margin-left: 16px;
          h2{
            color: rgb(81, 69, 139);
            font-size: 34px;
            line-height: 40px;
            font-weight: bold;
          }
          p{
            font-size: 14px;
            color: rgba(0, 0, 0, 0.54);
            line-height: 24px;
          }
        }
        .description{
          text-align: right;
          .ivu-btn{
            padding: 0;
            font-weight: 500;
            height: 36px;
            width: 102px;
            background-color: rgba(0, 0, 0, 0.12);
            color: @primary-color;
            border: none;
            box-shadow: none;
          }
          p{
            color: rgba(0, 0, 0, 0.26);
            font-size: 12px;
            line-height: 16px;
            margin-top: 8px;
            &:after{
              content: '*';
              color: @primary-color;
              font-size: 12px;
            }
          }
        }
      }
      &__body{
        padding: 0 24px 8px;
        &-list{
          text-align: center;
          .list-item {
            display: inline-block;
            vertical-align: middle;
            margin-right: 8px;
            width: 296px;
            height: 448px;
            background-color: #fff;
            box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
            0 6px 30px 5px rgba(0, 0, 0, .08),
            0 8px 10px 0 rgba(0, 0, 0, .16);
            border-radius: 8px;
            border-top: 8px solid rgb(81, 69, 139);
            overflow: hidden;
            text-align: center;
            padding-top: 8px;
            margin-bottom: 20px;
            position: relative;
            cursor: pointer;
            &:last-child{
              margin-right: 0;
            }
            &.active{
              border-top: 8px transparent solid;
              border-image:linear-gradient(to left,rgb(247, 107, 28),rgb(250, 217, 97)) 1 10;
              background-image: linear-gradient(to bottom, rgb(179, 132, 255), rgb(124, 77, 255));
              width: 336px;
              height: 480px;
              padding-top: 16px;
              z-index: 9;
              .list-item {
                &__title{
                  color: rgb(255, 255, 255);
                  font-weight: 500;
                  font-size: 22px;
                  line-height: 32px;
                }
                &__body{
                  padding-top: 25px;
                  .amount{
                    width: 320px;
                    background-color: rgba(0, 0, 0, 0.26);
                    .num{
                      font-size: 48px;
                      color: #fff;
                      font-weight: bold;
                    }
                    .tag{
                      background: linear-gradient(to right, rgb(255, 152, 0), rgb(250, 217, 97));
                    }
                    .star{
                      .v-icon{
                        color: rgba(0, 0, 0, 0.54);
                      }
                    }
                  }
                  .detail{
                    p{
                      &:nth-child(1){
                        color: rgba(255, 255, 255, 0.7);
                      }
                      &:nth-child(2){
                        color: rgba(255, 255, 255, 0.7);
                      }
                      &:nth-child(3){
                        color: rgba(255, 255, 255, 0.3);
                        &:after{
                          color: rgb(80, 227, 194);
                        }
                      }
                    }
                  }
                }
              }
            }
            &__title{
              font-size: 12px;
              color: rgba(0, 0, 0, 0.54);
            }
            &__body{
              padding: 30px 8px 0;
              .amount{
                height: 168px;
                width: 280px;
                background-color: rgba(0, 0, 0, 0.08);
                border-top-left-radius: 24px;
                border-top-right-radius: 24px;
                padding-top: 40px;
                position: relative;
                .num{
                  color: rgb(81, 69, 139);
                  font-size: 40px;
                  line-height: 48px;
                  margin-bottom: 16px;
                }
                .tag{
                  border-radius: 16px;
                  height: 32px;
                  line-height: 32px;
                  background-color: rgb(255, 171, 64);
                  padding: 0 16px;
                  color: rgba(0, 0, 0, 0.54);
                  font-size: 14px;
                  display: inline-block;
                }
                .star{
                  position: absolute;
                  height: 45px;
                  width: 45px;
                  left: 16px;
                  top: -24px;
                  img{
                    height: 45px;
                    width: 45px;
                  }
                  .v-icon{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: rgb(255, 171, 64);
                  }
                }
              }
              .detail{
                padding-top: 48px;
                > p{
                  margin-bottom: 4px;
                  &:nth-child(1){
                    color: rgba(0, 0, 0, 0.54);
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 20px;
                  }
                  &:nth-child(2){
                    color: rgba(0, 0, 0, 0.54);
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                  }
                  &:nth-child(3){
                    color: rgba(0, 0, 0, 0.26);
                    font-size: 12px;
                    line-height: 18px;
                    &:after{
                      content: '*';
                      color: @primary-color;
                    }
                  }
                }
              }
            }
          }
        }
        &-order{
          .title{
            color: rgb(81, 69, 139);
            font-size: 18px;
            line-height: 32px;
            font-weight: 500;
          }
          .order-list{
            padding-top: 8px;
            border-top: 3px solid rgb(81, 69, 139);
            border-bottom: 1px solid rgb(81, 69, 139);
            li{
              margin-bottom: 8px;
              color: rgba(0, 0, 0, 0.54);
              font-size: 14px;
              line-height: 24px;
            }
          }
        }
      }
      &__footer{
        padding: 0 24px;
        .label{
          color: rgb(81, 69, 139);
          font-weight: bold;
          font-size: 22px;
          line-height: 32px;
        }
        .ivu-btn{
          font-weight: 500;
          margin-top: 24px;
        }
      }
    }
    &-custom{
      padding-bottom: 32px;
      overflow: auto;
      &__header{
        padding: 8px 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        .v-icon{
          color: @primary-color;
          margin-right: 32px;
          vertical-align: top;
          position: relative;
          top: 5px;
          cursor: pointer;
        }
        .title{
          display: inline-block;
          h2{
            color: rgba(0, 0, 0, 0.54);
            font-size: 22px;
            line-height: 32px;
          }
          p{
            color: rgba(0, 0, 0, 0.26);
            font-size: 12px;
            line-height: 16px;
            &:after{
              content: '*';
              color: @primary-color;
            }
          }
        }
      }
      &__body{
        padding: 24px 16px;
        .icon-wrapper{
          flex-basis: 40px;
          width: 40px;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.08);
          padding-top: 8px;
          text-align: center;
          border-radius: 50%;
          .v-icon{
            color: rgb(81, 69, 139);
          }
        }
        .ivu-form{
          padding-left: 16px;
          padding-top: 5px;
          flex: 1;
          h3{
            color: rgb(81, 69, 139);
            font-size: 18px;
            line-height: 32px;
            margin-bottom: 28px;
          }
          .ivu-form-item-label{
            color: rgba(0, 0, 0, 0.54);
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 4px;
          }
          .ivu-input{
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.87);
            font-weight: 500;
            border-color: rgba(0, 0, 0, 0.08);
            box-shadow: none;
          }
        }
        .ivu-btn{
          margin-top: 64px;
          border: none;
          box-shadow: none;
          padding: 0;
          height: 36px;
          &[disabled]{
            background-color: rgba(0, 0, 0, 0.12);
            color: rgba(0, 0, 0, 0.26);
            font-weight: 500;
          }
        }
        .ivu-input-group-append{
          background-color: unset;
          border: none;
        }
      }
    }
    &-pay{
      padding-bottom: 32px;
      overflow: auto;
      font-weight: 500;
      &__header{
        padding: 28px 24px 12px;
        h2{
          color: rgb(81, 69, 139);
          font-size: 34px;
          line-height: 40px;
        }
        p{
          color: rgba(0, 0, 0, 0.54);
          font-size: 14px;
          line-height: 24px;
        }
      }
      &__body{
        padding: 0 8px;
        &-detail{
          background-color: rgb(236, 239, 241);
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 8px;
          h3{
            font-size: 18px;
            color: rgba(0, 0, 0, 0.87);
            line-height: 32px;
            margin-bottom: 10px;
            font-weight: 500;
          }
          ul{
            border-top: 3px solid rgba(0, 0, 0, 0.87);
            border-bottom: 1px solid rgba(0, 0, 0, 0.87);
            margin-bottom: 8px;
            padding-top: 8px;
            li{
              margin-bottom: 8px;
              color: rgba(0, 0, 0, 0.54);
              font-size: 14px;
              line-height: 24px;
            }
          }
          h2{
            color: rgba(0, 0, 0, 0.87);
            font-size: 22px;
            line-height: 32px;
            font-weight: bold;
          }
        }
        &-info{
          padding: 16px 16px 32px;
          background-color: rgb(236, 239, 241);
          border-radius: 8px;
          h3{
            color: rgba(0, 0, 0, 0.87);
            font-size: 18px;
            line-height: 32px;
            font-weight: 500;
            margin-bottom: 8px;
          }
          ul{
            border-top: 3px solid rgba(0, 0, 0, 0.87);
            padding-top: 8px;
            li{
              margin-bottom: 16px;
              &.top{
                margin-top: 24px;
              }
              .label{
                color: rgba(0, 0, 0, 0.54);
                font-size: 12px;
                line-height: 24px;
              }
              .value{
                color: rgba(0, 0, 0, 0.87);
                font-size: 14px;
                line-height: 24px;
              }
              .remark{
                color: rgb(239, 108, 0);
                font-size: 14px;
                line-height: 24px;
                &:after{
                  content: '**';
                  color: rgb(81, 69, 139);
                }
              }
            }
          }
        }
      }
      &__footer{
        padding: 16px;
        .ivu-btn{
          font-weight: 500;
          border: none;
          box-shadow: none;
        }
        .ivu-btn-text{
          color: @primary-color;
          margin-top: 8px;
          &[disabled] {
            color: rgba(0, 0, 0, .56);
            &:hover{
              color: rgba(0, 0, 0, .56);
            }
          }
          &:hover{
            color: @link-hover-color;
          }
        }
      }
    }
  }
</style>
